import { ListItem } from './type';

const model = {
  state: {
    currShop: {},
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { dataComment } }: any) => ({
    // 获取计提类型详情
    setCurrShop(currShop: ListItem) {
      dataComment.setState({ currShop });
    },
  }),
};

export default model;
